import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Form as FinalForm } from 'react-final-form';
import { Container, Form } from 'reactstrap';

import useFetch from '../../../hooks/useFetch';
import ContainerWithCard from '../../../components/ContainerWithCard';
import SectionEditFormButtons from '../../../components/SectionEditFormButtons';
import FormFieldSwitchPill from '../../../components/formFields/FormFieldSwitchPill';
import FormFieldTextOrNumber from '../../../components/formFields/FormFieldTextOrNumber';
import { getIntegrationOpenAi, updateIntegrationOpenAi } from '../../../redux/methods/integrations';

type OpenAiSettingsView =
{
    enabled?: boolean;
    hasApiKey?: boolean;
    model?: string;
};

type OpenAIProperties =
{
    getIntegrationOpenAi: () => any;
    updateIntegrationOpenAi: (formData: { enabled?: boolean; apiKey?: string; model?: string }) => any;
};

function OpenAI({ getIntegrationOpenAi, updateIntegrationOpenAi }: OpenAIProperties)
{
    const intl = useIntl();
    const translations = (intl.messages as any).integrations.openai;
    const [data] = useFetch(getIntegrationOpenAi) as unknown as [OpenAiSettingsView | undefined, number | undefined, any];

    if (!data)
    {
        return <ContainerWithCard title={translations.title} iconClass="fa fa-robot">{null}</ContainerWithCard>;
    }

    return (
        <ContainerWithCard title={translations.title} iconClass="fa fa-robot">
            <FinalForm
                keepDirtyOnReinitialize
                initialValues={{ ...data, apiKey: '' }}
                onSubmit={updateIntegrationOpenAi}
                render={({ handleSubmit, form }) => (
                    <Form onSubmit={handleSubmit}>
                        <Container fluid>
                            <div className="my-2">
                                <FormFieldSwitchPill
                                    label={translations.labels.enabled}
                                    name="enabled"
                                    className="w-100"
                                />
                            </div>
                            <div className="mt-3">
                                <FormFieldTextOrNumber
                                    type="password"
                                    label={translations.labels.apiKey}
                                    name="apiKey"
                                />
                                {data.hasApiKey && (
                                    <small className="text-muted d-block mt-1">
                                        API key is already configured. Leave this field empty to keep the current key.
                                    </small>
                                )}
                            </div>
                            <div className="mt-3">
                                <FormFieldTextOrNumber
                                    label={translations.labels.model}
                                    name="model"
                                />
                            </div>
                            <SectionEditFormButtons formReset={form.reset} />
                        </Container>
                    </Form>
                )}
            />
        </ContainerWithCard>
    );
}

const mapDispatch = {
    getIntegrationOpenAi,
    updateIntegrationOpenAi,
};

export default connect(null, mapDispatch)(OpenAI);
